import { useEffect, useState } from "react";
import api from "../../services/api";
import { getImageUrl } from "../../utils/media";
import "./style.css";

const DEFAULT_SOCIALS = [
  {
    name: "LinkedIn",
    url: "https://www.linkedin.com/company/instituto-7-gerações/",
    iconUrl: "/linkedin.svg",
  },
  {
    name: "Instagram",
    url: "https://www.instagram.com/7geracoes/",
    iconUrl: "https://cdn.simpleicons.org/instagram/FFFFFF",
  },
  {
    name: "YouTube",
    url: "https://www.youtube.com/@7geracoes962",
    iconUrl: "https://cdn.simpleicons.org/youtube/FFFFFF",
  },
];

const DEFAULT_FOOTER = {
  logoLink: "/login",
  contact: {
    email: "comunicacao@7geracoes.com",
    phone: "(35) 3822-6251",
    cnpj: "28.932.203/0001-35",
  },
  socials: DEFAULT_SOCIALS,
  donationLink: "https://7geracoes.apoiar.co/",
  copyright: "2026 © 7 Gerações. Todos os direitos reservados.",
};

export default function Footer() {
  const [footer, setFooter] = useState(DEFAULT_FOOTER);

  useEffect(() => {
    api.get("/config/footer")
      .then(({ data }) =>
        setFooter((current) => ({
          ...current,
          ...data,
          socials: DEFAULT_SOCIALS.map((social) => {
            const saved = data.socials?.find((item) => item.name === social.name);
            return {
              ...social,
              ...(saved || {}),
              iconUrl: social.iconUrl,
            };
          }),
          contact: { ...current.contact, ...data.contact },
        })),
      )
      .catch(() => undefined);
  }, []);

  return (
    <footer className="footer">
      <div className="footer__inner">
        <div className="footer__left">
          <div className="footer__contact">
            <p className="footer__contact-title">Contato</p>
            <p>E-mail: {footer.contact.email}</p>
            <p>Telefone: {footer.contact.phone}</p>
            <p>CNPJ: {footer.contact.cnpj}</p>
          </div>
          <div className="footer__socials">
            {footer.socials.map((social) => (
              <a
                key={`${social.name}-${social.url}`}
                href={social.url}
                className="footer__social-link"
                target="_blank"
                rel="noopener noreferrer"
                aria-label={social.name}
              >
                {getImageUrl(social.iconUrl) ? (
                  <img src={getImageUrl(social.iconUrl)} alt="" />
                ) : (
                  social.name.charAt(0)
                )}
              </a>
            ))}
          </div>
          <p className="footer__copyright">{footer.copyright}</p>
        </div>
        <div className="footer__right">
          {getImageUrl(footer.seal) ? (
            <img
              src={getImageUrl(footer.seal)}
              alt="Selo institucional"
              className="footer__evoluir"
            />
          ) : (
            <img src="/evoluir.png" alt="Programa Evoluir" className="footer__evoluir" />
          )}
          <a
            href={footer.logoLink}
            className="footer__logo"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Logo 7 Gerações"
          >
            <img src={getImageUrl(footer.logo) || "/7G_FOOTER_LOGO.png"} alt="7 Gerações" />
          </a>
        </div>
      </div>
    </footer>
  );
}
